import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { QueryInput } from "../components";
import {
  getSettings,
  fetchCodeDetails,
} from "../../../shared/utilities/actions";
import {
  Settings,
  DefaultSettings,
  CodeDetails,
  DefaultCodeDetails,
  Query,
  DefaultQuery,
} from "../../../shared/types";

export interface MainProps {}

export const Main = (props: MainProps): React.JSX.Element => {
  const [busy, setBusy] = useState<boolean>(true);
  const [codeDetails, setCodeDetails] = useState<CodeDetails>({
    ...DefaultCodeDetails,
  });
  const [settings, setSettings] = useState<Settings>({ ...DefaultSettings });
  const [query, setQuery] = useState<Query>({ ...DefaultQuery });

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let params = new URLSearchParams(document.location.search);
      let queryParameterText = params.get("text");
      let queryParameterCat = params.get("cat");
      let queryParameterRange = params.get("range");
      let queryParameterLat = params.get("latitude");
      let queryParameterLon = params.get("longitude");
      let queryParameterSize = params.get("size");
      let queryParameterSkip = params.get("skip");

      setQuery({
        text: queryParameterText ? queryParameterText : "",
        category: queryParameterCat ? queryParameterCat : "",
        range: queryParameterRange ? parseInt(queryParameterRange) : 0,
        latitude: queryParameterLat ? parseFloat(queryParameterLat) : 0,
        longitude: queryParameterLon ? parseFloat(queryParameterLon) : 0,
        size: queryParameterSize ? parseInt(queryParameterSize) : 50,
        skip: queryParameterSkip ? parseInt(queryParameterSkip) : 0,
      });
      let themeId = fetchCodeDetails(codeDetails.themeId, setCodeDetails);
      let settingsResponse: Settings = await getSettings(themeId);
      setSettings(settingsResponse);
      setBusy(false);
    };
    fetchData();
  }, []);

  return (
    <QueryInput
      settings={settings}
      busy={busy}
      query={query}
      handleSearch={async () => {
        setBusy(true);
        window.location.href = `${
          settings.searchResultsUrl
        }?text=${encodeURIComponent(query?.text)}${
          query?.category ? `&cat=${encodeURIComponent(query?.category)}` : ""
        }${query?.range ? `&range=${encodeURIComponent(query?.range)}` : ""}${
          query?.latitude
            ? `&latitude=${encodeURIComponent(query?.latitude)}`
            : ""
        }${
          query?.longitude
            ? `&longitude=${encodeURIComponent(query?.longitude)}`
            : ""
        }${query?.size ? `&size=${encodeURIComponent(query?.size)}` : ""}${
          query?.skip ? `&skip=${encodeURIComponent(query?.skip)}` : ""
        }`;
      }}
      handleQueryChange={(value: Query) => {
        setQuery(value);
      }}
    />
  );
};
